import React, { useState } from 'react';
import { useAuth } from '../../contexts';

const ResetPasswordForm: React.FC = () => {
  const { resetPassword, isLoading, error } = useAuth();
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await resetPassword(email);
    setSubmitted(true);
  };

  if (submitted && !error) {
    return (
      <div className="w-full max-w-md mx-auto p-6">
        <div className="bg-green-50 text-green-700 p-4 rounded-md">
          <h3 className="font-semibold mb-2">Check your email</h3>
          <p>
            We've sent password reset instructions to {email}. Please check your inbox.
          </p>
        </div>
        <button
          onClick={() => setSubmitted(false)}
          className="mt-4 text-accent-purple hover:underline text-sm"
        >
          Try another email
        </button>
      </div>
    );
  }

  return (
    <div className="w-full max-w-md mx-auto p-6">
      <h2 className="text-2xl font-bold mb-6 text-center">Reset Password</h2>
      <p className="text-gray-600 mb-6 text-center">
        Enter your email address and we'll send you instructions to reset your password.
      </p>
      
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
            Email
          </label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-accent-purple"
            placeholder="Enter your email"
          />
        </div>

        {error && (
          <div className="bg-red-50 text-red-500 p-3 rounded-md text-sm">
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={isLoading}
          className="w-full bg-accent-purple text-white py-2 px-4 rounded-md hover:bg-opacity-90 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed"
        >
          {isLoading ? 'Sending...' : 'Send Reset Instructions'}
        </button>

        <div className="text-center mt-4">
          <a href="/login" className="text-accent-purple hover:underline text-sm">
            Back to Sign In
          </a>
        </div>
      </form>
    </div>
  );
};

export default ResetPasswordForm; 